import NumberValueObject from "../../../shared/domain/value-object/number-value-object";

export default class AnimeScore extends NumberValueObject {

}